<template>
  <footer class="bottom-nav">
    <router-link to="/" class="nav-item" active-class="active">
      <el-icon><HomeFilled /></el-icon>
      <div class="nav-text">首页</div>
    </router-link>
    
    <router-link to="/parking" class="nav-item" active-class="active">
      <el-icon><Location /></el-icon>
      <div class="nav-text">车位优选</div>
    </router-link>
    
    <router-link to="/discount" class="nav-item" active-class="active">
      <el-icon><Discount /></el-icon>
      <div class="nav-text">优惠</div>
    </router-link>
    
    <router-link to="/profile" class="nav-item" active-class="active">
      <el-icon><User /></el-icon>
      <div class="nav-text">我的</div>
    </router-link>
  </footer>
</template>

<script>
import { HomeFilled, Location, Discount, User } from '@element-plus/icons-vue'

export default {
  name: 'AppFooter',
  components: {
    HomeFilled,
    Location,
    Discount,
    User
  }
}
</script>

<style scoped>
.bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  background-color: white;
  box-shadow: 0 -1px 2px rgba(0, 0, 0, 0.1);
  height: 55px;
  z-index: 100;
}

.nav-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #909399;
  font-size: 10px;
  padding: 4px 0;
  text-decoration: none;
}

.nav-item.active {
  color: #4080ff;
}

.nav-item .el-icon {
  font-size: 20px;
  margin-bottom: 2px;
}

.nav-text {
  margin-top: 1px;
}
</style> 